import * as stylex from '@stylexjs/stylex';
import React from 'react';
import { TinaMarkdown } from 'tinacms/dist/rich-text';
import { layout } from '../styles/layout';
import '../styles/tokens.stylex';
import { layoutTokens } from '../styles/tokens.stylex';
import { defaultRichTextComponents } from './RichText';
type Props = React.ComponentProps<typeof TinaMarkdown>;
export function BodyArticle({
  content,
  ...props
}: Props) {
  return <div {...stylex.props(layout.sectionWrapper)}>
      <div className="xgu5lr5 x12h1iku xrvj5dj x1ypdn0p xtpsss9 x1pt1dkn" {...props}>
        <TinaMarkdown content={content} components={props.components || defaultRichTextComponents} />
      </div>
    </div>;
}